module.exports = __webpack_public_path__ + "img/news23-0.8667a67e.png";